module.exports = __webpack_public_path__ + "img/hull_insurance.610d91ed.svg";